import { apiClient } from "./apiClient";

export const documentTypeService = {
  listAll: async () => {
    const res = await apiClient.get("/document-types");
    return res.data;
  },

  create: async (payload) => {
    const res = await apiClient.post("/document-types", payload);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await apiClient.put(`/document-types/${id}`, payload);
    return res.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/document-types/${id}`);
  },

  getBySindicato: async (sindicatoViewId) => {
    const res = await apiClient.get(`/sindicato-views/${sindicatoViewId}/document-types`);
    return res.data;
  },

  setSindicatoTypes: async (sindicatoViewId, typeIds) => {
    const res = await apiClient.put(`/sindicato-views/${sindicatoViewId}/document-types`, typeIds);
    return res.data;
  },
};
